let currentCoder = "正式"; //客户端开发者，调试时更改 以区分服务端API，与下方api.baseUrl一一对应；

let baseUrl = "https://testapi.ctgpayroll.com/authen/";
let imgBaseUrl = "http://47.92.110.143:8090/upload/";
let ssqBaseUrl = "https://ssqt.ctgpayroll.com/html/wages/emptysuc.html";

let videoProfileName = "test";
export default {
    GetApiBaseUrl: function() {
        //----------- 自定义API地址---begin-----根据currentCoder与他人区分-
        //
        baseUrl = currentCoder == "正式" ? "https://autodiscover.ctgpayroll.com/authen" : baseUrl;

        baseUrl = currentCoder == "143" ? "https://testapi.ctgpayroll.com/authen" : baseUrl;

        // 
        baseUrl = currentCoder == "本地" ? "http://192.168.160.147:8772/authen" : baseUrl;

        baseUrl = currentCoder == "模拟" ? "https://qysmallwxdebug.ctgpayroll.com/authen" : baseUrl;

        baseUrl = location.href.toLocaleLowerCase().indexOf("localhost:8085") >= 0 ? "https://testapi.ctgpayroll.com/authen" : baseUrl;
        // baseUrl = location.href.toLocaleLowerCase().indexOf("localhost:8085") >= 0 ? "http://192.168.160.157:8080/ehr_saas" : baseUrl;
        //-----------------------------end--------------------------------------------------------------------
        return baseUrl;
    },
    GetImgBaseUrl: function() {
        //----------- 自定义IMG地址---begin-----根据currentCoder与他人区分-------------------------------
        //
        imgBaseUrl = currentCoder == "正式" ? "https://file.ctgpayroll.com/upload/" : imgBaseUrl;

        //
        imgBaseUrl = currentCoder == "本地" ? "http://192.168.160.164:8090/upload/" : imgBaseUrl;
        //      
        //
        imgBaseUrl = currentCoder == "143" ? "http://47.92.110.143:8090/upload/" : imgBaseUrl;
        //

        //-----------------------------end--------------------------------------------------------------------
        return imgBaseUrl;
    },
    GetSsqBaseUrl: function() {

        //----------- 上上签------------------------------
        //
        ssqBaseUrl = currentCoder == "正式" ? "https://owa.ctgpayroll.com/html/wages/emptysuc.html" : ssqBaseUrl;

        //
        ssqBaseUrl = currentCoder == "本地" ? "https://ssqt.ctgpayroll.com/html/wages/emptysuc.html" : ssqBaseUrl;
        //      
        //
        ssqBaseUrl = currentCoder == "143" ? "https://ssqt.ctgpayroll.com/html/wages/emptysuc.html" : ssqBaseUrl;

        return ssqBaseUrl;
    },
    GetVideoProfileName: function() {
        //----------- 和缓医生------------------------------ 
        //
        videoProfileName = currentCoder == "正式" ? "prod" : videoProfileName;

        //
        videoProfileName = currentCoder == "本地" ? "test" : videoProfileName;
        //      
        //
        videoProfileName = currentCoder == "143" ? "test" : videoProfileName;
        //
        return videoProfileName;
    }
}

//-----------------------------end------------------------------------------